import styled from 'styled-components';
import {
  CheckCircleFilled,
  InfoCircleFilled,
  WarningFilled,
  CloseCircleFilled,
  SmileOutlined,
  UploadOutlined,
} from '@ant-design/icons';
import { Alert } from 'antd';
import { FanguardApiContractsNotificationIndicatorEnumKeys } from 'src/api/generated';

interface StyledAlertProps {
  indicator: FanguardApiContractsNotificationIndicatorEnumKeys;
}

export const StyledAlert = styled(Alert)<StyledAlertProps>`
  .ant-alert-message {
    margin-bottom: 0;
  }
  .ant-alert-close-icon {
    font-size: 12px;
    color: ${({ theme }) => theme.colorTextTertiary};
  }
  .ant-alert-description {
    .ant-typography:first-child {
      color: ${({ theme }) => theme.colorTextLabel};
    }
    .ant-typography:last-child {
      color: ${({ theme }) => theme.colorTextTertiary};
    }
  }
  background-color: ${({ theme }) => theme.colorBgContainer};
  border-radius: 0;
  border: none;
  border-bottom: 1px solid ${({ theme }) => theme.colorBorderSecondary};
  border-left: 4px solid
    ${({ theme, indicator }) => {
      switch (indicator) {
        case 'Success':
          return theme.colorSuccess;
        case 'Warning':
          return theme.colorWarning;
        case 'Failure':
          return theme.colorError;
        case 'Information':
          return theme.colorInfo;
        case 'BulkImport':
          return theme.colorTextTertiary;
        default:
          return theme.colorInfo;
      }
    }};
  &:last-of-type {
    border-bottom: none;
  }
`;

export const CheckCircleFilledIcon = styled(CheckCircleFilled)`
  svg {
    color: ${({ theme }) => theme.colorSuccess};
  }
`;

export const InfoCircleFilledIcon = styled(InfoCircleFilled)`
  svg {
    color: ${({ theme }) => theme.colorInfo};
  }
`;

export const WarningFilledIcon = styled(WarningFilled)`
  svg {
    color: ${({ theme }) => theme.colorWarning};
  }
`;

export const CloseCircleFilledIcon = styled(CloseCircleFilled)`
  svg {
    color: ${({ theme }) => theme.colorError};
  }
`;

export const SmileOutlinedIcon = styled(SmileOutlined)`
  svg {
    color: ${({ theme }) => theme.colorTextTertiary};
  }
`;

export const BulkImportIcon = styled(UploadOutlined)`
  svg {
    color: ${({ theme }) => theme.colorTextTertiary};
  }
`;
